const url = window.location.origin;
let api;
if (url.includes('localhost')) {
  api = 'http://localhost:5194/api';
} else {
  api = url + '/api';
}

async function getProjects() {
  try {
    const response = await fetch(`${api}/projects`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
}

async function getProjectsPeriod() {
  try {
    const response = await fetch(`${api}/projects/period`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching projects period:', error);
    throw error;
  }
}

async function getProjectById(id) {
  try {
    const response = await fetch(`${api}/projects/${id}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching project:', error);
    throw error;
  }
}

async function getCommuneByName(commune) {
  try {
    const response = await fetch(`${api}/communes/${commune}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
}

async function getBuilderByName(builder) {
  try {
    const response = await fetch(`${api}/builders/${builder}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
}

async function getCommunes() {
  try {
    const response = await fetch(`${api}/communes`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
}

async function getBuilders() {
  try {
    const response = await fetch(`${api}/builders`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
}

async function getBuildingTypes() {
  try {
    const response = await fetch(`${api}/building-types`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
}

export default { getProjects, getProjectsPeriod, getProjectById, getCommuneByName, getBuilderByName, getCommunes, getBuilders, getBuildingTypes };
